module.exports = __webpack_public_path__ + "img/child.da1d0f5b.png";